module.exports = __webpack_public_path__ + "do.svg?b656eac95d26c59cf6ba0ee70000e561";